import React from 'react';

import {
    LoaderWrapper,
    LoadingRingOne,
    LoadingRingTwo,
    LoadingRingThree,
    LoaderRingProps,
} from 'styles/loader';

export const Loader = (props: LoaderRingProps) => (
    <LoaderWrapper>
        <LoadingRingOne {...props} />
        <LoadingRingTwo {...props} />
        <LoadingRingThree {...props} />
    </LoaderWrapper>
);
